import React from 'react';
import _ from 'lodash';
import DropDown from '../../components/common/DropDown';
import InputFields from '../../components/common/InputFields';
import AntDateFieldsComponent from '../../components/common/AntDatePickerFields';
import DateInput from '../../components/common/DateBar';
import CheckboxComponent from '../../components/common/CheckBox';
import SearchableDropdownComponent from '../../components/common/SearchableDropDown';
import ToggleComponent from '../../components/common/Toggle';
import { options } from '@fullcalendar/core/preact';
import InputWithLabel from '../../components/common/InputwithLabel';
import SelectionItemDropDown from '../../components/common/SelectionItemDropDown';
import RadioButtonComponent from '../../components/common/Radios';
import { useSelector } from 'react-redux';
import VillagesMapped from '@pages/GeoNonGeo/components/VillagesMapped';
interface formDataType {
  [key: string]: any;
}
interface objectType {
  [key: string]: any;
}
interface OptionType {
  label: string;
  value: string;
  code: string;
}

type propsType = {
  formData: formDataType;
  handleFormChange: (
    value: string | boolean | OptionType | any,
    key: string,
    field?: formDataType,
    option?: any,
    code?: any,
  ) => void;
  onInputChange?: (value:string, key:string) => any;
  formState: formDataType;
  verified?: any;
  savedItems?: any;
  onClickVerify?: (value: boolean) => void
  showVerifyLabel?: boolean;
  onDropDownClick?: (key: string) => void
  message?: string;
};

const FormFields = ({
  formData,
  handleFormChange,
  onInputChange,
  formState,
  verified,
  message,
  savedItems,
  showVerifyLabel,
  onClickVerify,
  onDropDownClick = () => { },
}: propsType) => {
  const storeData: any = useSelector(state => state);
  
  


  const formKeys = Object.keys(formData) as (keyof formDataType)[];

  return (
    <>
      {formKeys.map((element: any) => {
        const field: formDataType = formData[element];
        const fieldType = field['#type'];
        const title = field['#title'];
        const key: string = field['#webform_key'];
        const isDisabled: boolean = field['#isDisabled'];
        const showPlaceholder: boolean = field['#showPlaceholder'];
        const isMultiDropdown: boolean = field['#multiDropdown'];
        const isGroup = field['#group'];
        const dateMinimum = field['#dateMinimum'];
        const minDate = field['#minDate'];
        const maxDate = field['#maxDate'];
        const isVisible = field['#isVisible'];
        const tooltipNeeded = field['#tooltipNeeded'];
        const tooltipText = field['#tooltipText'];
        const showSelectedOption: boolean = field['#showSelectedOption'];
        const disableIndividualDates = field['#individualDates'] ? field['#individualDates'] : [];
        const isRequired =
          field['#required'] && field['#required'] === true ? true : false;
        if (fieldType === 'select') {
          const dataOptions = field['#options'];
          let options;
          const options2: string[] = dataOptions
            ? Object.values(dataOptions)
            : [];
          if (field['#webform_key'] == 'facility_category') {
            options = field['#options'];
          }
          else if (field['#webform_key'] == 'facility_type') {
            options = field['#options']
          } else if (field['#webform_key'] == 'ownership') {
            options = field['#options']
          } else if (field['#webform_key'] == 'administrative_body') {
            options = field['#options']
          } else if (field['#webform_key'] == 'central_govt_dept') {
            options = field['#options']
          } else if (field['#webform_key'] == 'status') {
            options = field['#options']
            // options = options2.map((option1: any) => ({
            // value: option1.status,
            // label: option1.status,
            // id: option1.satus_id,
            // }));
          } else if (field['#webform_key'] == 'state') {
            options = options2.map((option1: any) => ({
              value: `${option1.state_name}-${option1.state_code}`,
              label: `${option1.state_name}-${option1.state_code}`,
              id: option1.state_id,
              code: option1.state_code,
            }));
          } else if (field['#webform_key'] == 'district') {
            options = options2.map((option1: any) => ({
              value: `${option1.district_name}-${option1.district_code}`,
              label: `${option1.district_name}-${option1.district_code}`,
              id: option1.district_id,
              code: option1.district_code
            }));
          } else if (field['#webform_key'] == 'type') {
            options = options2.map((option1: any) => ({
              value: `${option1.type_name}`,
              label: `${option1.type_name}`,
              id: option1.type_id,
              code: option1.type_code
            }));
          }

          else if (field['#webform_key'] == 'ulb') {
            options = field['#options'];
            // options = options2.map((option1: any) => ({
            //   value: `${option1.ulb_name}-${option1.ulb_code}`,
            //   label: `${option1.ulb_name}-${option1.ulb_code}`,
            //   id: option1.ulb_id,
            //   code: option1.ulb_code,
            // }));
          } else if (field['#webform_key'] == 'block') {
            options = options2.map((option1: any) => ({
              value: `${option1.block_name}-${option1.block_code}`,
              label: `${option1.block_name}-${option1.block_code}`,
              id: option1.block_id,
              code: option1.block_code,
            }));
          }
          else if (field['#webform_key'] == 'health_block') {
            options = options2.map((option1: any) => ({
              value: `${option1.heal_block_name}-${option1.heal_block_code}`,
              label: `${option1.heal_block_name}-${option1.heal_block_code}`,
              id: option1.health_block_id,
            }));
          } else if (field['#webform_key'] == 'sub_division') {
            options = options2.map((option1: any) => ({
              value: `${option1.sub_division_name}-${option1.sub_division_code}`,
              label: `${option1.sub_division_name}-${option1.sub_division_code}`,
              id: option1.sub_division_id,
            }));
          } 
        else if (field['#webform_key'] == 'ward') {
            options = field['#options'];
            //   options = options2.map((option1: any) => ({
            //   value: `${option1.ward_name}-${option1.ward_code}`,
            //   label: `${option1.ward_name}-${option1.ward_code}`,
            //   id: option1.ward_id,
            // }));
          } else if (field['#webform_key'] == 'parlimentary') {
            options = field['#options'];
          } else if (field['#webform_key'] == 'lac') {
            options = options2.map((option1: any) => ({
              value: `${option1.ac_name}-${option1.ac_code}`,
              label: `${option1.ac_name}-${option1.ac_code}`,
              id: option1.ac_id,
            }));
          } else if (field['#webform_key'] == 'sub_district') {
            options = options2.map((option1: any) => ({
              value: `${option1.sub_district_name}-${option1.sub_district_code}`,
              label: `${option1.sub_district_name}-${option1.sub_district_code}`,
              id: option1.sub_district_id,
              code: option1.sub_district_code,
            }));
          } else if (field['#webform_key'] == 'village') {
            options = options2.map((option1: any) => ({
              value: `${option1.village_name}-${option1.village_code}`,
              label: `${option1.village_name}-${option1.village_code}`,
              id: option1.village_id,
              code: option1.village_code,
            }));
          } 
          else if (field['#webform_key'] == 'gram_panchayat') {
            options = field['#options'];
          }
          else if (field['#webform_key'] == 'role_name') {
            options = field['#options'];
          }
          else if (field['#webform_key'] == 'rural_urban') {
            options = field['#options'];
          }
          else if (field['#webform_key'] == 'gram_panchayat_mapped') {
            options = field['#options'];
          }
          else if (field['#webform_key'] == 'villages_mapped') {
            options = field['#options'];
          }
          else if (field['#webform_key'] == 'wards_mapped') {
            options = field['#options'];
          }
          else if (field['#webform_key'] == 'type_name') {
            options = options2.map((option1: any) => ({
              value: option1.type_name,
              label: option1.type_name,
              id: option1.type_id,
              code:option1.type_code,
            }));
          }

          else {
            options = options2.map((option1: any) => ({
              value: option1.value,
              label: option1.label,
              code: option1.code,
              id: option1.id
            }));

          }
          const value = isMultiDropdown ? formState[key].value && formState[key].value?.map((key: string) => ({
            value: key,
            label: key,
          })) : formState[key].value ? {
            value: formState[key].value,
            label: formState[key].value,
          } : ''
          return (
            <div key={key} className={`${key}_wrapper ${isVisible?'showDropdown':'hideDropdown'}`} >
              {/* <DropDown
                dropDownName={title}
                className={key}
                disabled={false}
                options={options}
                onSelect={(changedData) => handleFormChange(changedData, key)}
                value={formState[key].value}
                defaultValue={dataOptions ? dataOptions[0] : ''}
              /> */}
              <SearchableDropdownComponent
                options={options}
                onChange={(changedData: any) => handleFormChange(isMultiDropdown ? changedData : changedData?.value, key, changedData?.id, options, changedData?.code )}
                onInputChange={(inputData:any)=> onInputChange && onInputChange(inputData, key)}                
                placeHolder={showPlaceholder ? 'Start typing minimum 3 characters to search' : title}
                multipleSelection={isMultiDropdown ? isMultiDropdown : false}
                dropDownType={formState[key].isError ? 'error' : 'general'}
                dropLabelName={title}
                ifRequired={isRequired}
                dropDownDisable={isDisabled}
                dropdownsearchable={true}
                value={value}
                errorMessage={formState[key].message}
                isClearable={true}
                showSelectedOption={showSelectedOption}
                tooltipNeeded={tooltipNeeded}
                toolTipText={tooltipText}

              // value={
              //   formState[key].value
              //     ? {
              //       value: formState[key].value,
              //       label: formState[key].value,
              //     }
              //     : null
              // }
              />
            </div>
          );
        } else if (fieldType === 'date') {
          return (
            <div key={key} className={`${key}_wrapper`}>
              <AntDateFieldsComponent
                placeholder={title}
                className={key}
                onChange={(changedData) => handleFormChange(changedData, key)}
                labelName={title}
                isDisabled={isDisabled}
                type="date"
                required={isRequired || false}
                value={formState[key].value}
                inputType={formState[key].isError ? 'error' : 'general'}
                errorMessage={formState[key].message}
                disablePastDates={dateMinimum}
                minDate={minDate}
                maxDate={maxDate}
                disableIndividualDates={disableIndividualDates}
              />
            </div>
          );
        }
        else if (fieldType === 'number') {
          return (
            <div key={key} className={`${key}_wrapper`}>
              <InputFields
                placeholder={title}
                className={key}
                onChange={(changedData) => handleFormChange(changedData, key)}
                labelName={title}
                isDisabled={isDisabled}
                type="number"
                required={isRequired || false}
                value={formState[key].value}
                inputType={formState[key].isError ? 'error' : 'general'}
                errorMessage={formState[key].message}
              />
            </div>
          );
        } else if (fieldType === 'verify') {
          
          return (
            <div key={key} className={`${key}_wrapper`}>
              <InputWithLabel
                labelName={title}
                inputwithlabelPlaceholder={title}
                inputlabelPlaceholder={'Verified'}
                inputlabeltype="text"
                disabled={isDisabled}
                verified={verified}
                showVerifyLabel={showVerifyLabel}
                onChange={(changedData) => handleFormChange(changedData, key)}
                inputlabelvalue={formState[key]?.value}
                inputType={formState[key]?.isError ? 'error' : 'general'}
                errorMessage={formState[key]?.message}
                verifyMessage={message}
                onClickVerify={verified[key] ? onClickVerify || function (value: boolean): void {
                  value = true;
                } : onClickVerify || function (value: boolean): void {
                  value = true;
                }}
                value={formState[key].value}
              />
            </div>
          );
        } else if (fieldType === 'radios') {
          return (
            <div key={key} className={`${key}_wrapper`}>
              < RadioButtonComponent
                radioName={title}
                radioButtonGroup={isGroup}
                disabled={isDisabled}
                onRadioButtonChange={(changedData) => handleFormChange(changedData, key)} />
            </div>
          );
        } else if (fieldType === 'checkbox') {
          return (
            <div key={key} className={`${key}_wrapper`}>
              <CheckboxComponent
                className=''
                placeCheckboxBefore={false}
                isChecked={formState[key].value}
                checkBoxName={title}
                disabled={isDisabled === true ? true : false || false}
                onCheckboxChange={(changedData) => handleFormChange(changedData, key)}
              />
            </div>
          );
        }
        else if (fieldType === 'toggle') {
          const dataOptions = field['#options'];
          const options: string[] = dataOptions
            ? Object.values(dataOptions)
            : [];
          return (
            <div key={key} className={`${key}_wrapper`}>
              <ToggleComponent
                onToggleChange={(changedData) =>
                  handleFormChange(changedData, key)
                }
                switchName={title}
                Disabled={isDisabled}
                switchId=""
                checked={formState[key].value}
                switchOnOffNames={options}
              />
            </div>
          );
        } else if (fieldType === 'checkboxes') {
          const checkboxOptions = field['#options'];
          if (!_.isEmpty(checkboxOptions)) {
            return _.keys(checkboxOptions).map((option) => {
              const optionsKey = checkboxOptions[option];
              const removeSpecialChar = option.replace(/[\s?]/g, '_');
              return (
                <div key={option} className={`${removeSpecialChar}_wrapper`}>
                  <CheckboxComponent
                    className={optionsKey}
                    placeCheckboxBefore={false}
                    isChecked={formState[optionsKey]?.value}
                    checkBoxName={optionsKey}
                    disabled={false}
                    onCheckboxChange={(changedData: boolean) => {
                      handleFormChange(changedData, optionsKey);
                    }}
                  />
                </div>
              );
            });
          }
          return;
        } else if (fieldType === 'selectionDropdown') {

          return (
            <div key={key} className={`${key}_wrapper ${isVisible?'showDropdown':'hideDropdown'}`}>
              <SelectionItemDropDown
                dropDownClick={() => onDropDownClick(key)}
                placeHolder={title}
                multipleSelection={true}
                dropDownType={formState[key].isError ? 'error' : 'general'}
                dropLabelName={title}
                ifRequired={isRequired}
                dropDownDisable={true}
                dropdownsearchable={true}
                savedItems={savedItems[key]}
                errorMessage={formState[key].message}

              />
            </div>
          );
        }
        else if (fieldType === 'webform_section') {
          
          return (
            <>
              <FormFields
                formData={field}
                handleFormChange={handleFormChange}
                formState={formState}
              />
              <div className={`hr1-form-${key}`}></div>
            </>
          );
        } else if (fieldType === 'textfield') {
          return (
            <div key={key} className={`${key}_wrapper`}>
              <InputFields
                placeholder={title}
                className={key}
                onChange={(changedData) => handleFormChange(changedData, key)}
                labelName={title}
                isDisabled={isDisabled}
                type="text"
                required={isRequired || false}
                value={formState[key].value}
                inputType={formState[key].isError ? 'error' : 'general'}
                errorMessage={formState[key].message}
              />
            </div>
          );
        }
        else if (fieldType === "selectionModal") {
          return <div key="showModal" 
          // style={formState[key].isDisable?{
          //   pointerEvents:'none',opacity:'0.5',cursor:'not-allowed'
          // }:{}
          // }
          className={`${key}_wrapper`}>
            <VillagesMapped labelName={title}
              formData={title === "Villages Mapped" ? formData['villages_mapped'] : formData['wards_mapped']} 
              formState={title === "Villages Mapped" ? formState['villages_mapped'] : formState['wards_mapped']}
              isDisabled={isDisabled}
              allFormState = {formState} 
              allFormData = {formData}
              />
          </div>
        }
      })}
    </>
  );
};

export default FormFields;

